/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_USER_LIST = gql`
  query GetAllBlackListedUsers(
    $filter: CreateBlockListUser
    $options: GetManyOptions
  ) {
    getAllBlackListedUsers(filter: $filter, options: $options) {
      content {
        firstName
        fullName
        lastName
        email
        accountStatus
        role {
          name
          state
          uuid
        }
        Invites {
          invitedBy {
            firstName
            lastName
          }
        }
        gender
        inviteStatus
      }
      count
      limit
      skip
    }
  }
`;

// $input: RoleListInput

// getListOfRole(input: $input) {
//   totalCount
//   data
// }
